import TileLayer from "ol/layer/Tile.js"
import TileWMS from 'ol/source/TileWMS.js';

import ImageLayer  from "ol/layer/Image.js"
import ImageWMS from 'ol/source/ImageWMS.js';

import {urlGeoserver} from "./globals";

const brForetWmsLayer0 = new TileLayer({
    source: new TileWMS({
        url: urlGeoserver+'ref_geo/wms', // URL du service WMS
        params: {
            'LAYERS': 'ref_geo:br_forets',
            'TILED': true
        },
        serverType: 'geoserver',// Type de serveur WMS (ex: geoserver)
        crossOrigin: 'anonymous'// Permet les requêtes cross-origin (CORS)
    }),
    opacity:0.5,
    visible:false,
    title:"Biorégions forêts"
});

const brGeologieWmsLayer0 = new TileLayer({
    source: new TileWMS({
        url: urlGeoserver+'ref_geo/wms', // URL du service WMS
        params: {
            'LAYERS': 'ref_geo:br_geologie',
            'TILED': true
        },
        serverType: 'geoserver',// Type de serveur WMS (ex: geoserver)
        crossOrigin: 'anonymous'// Permet les requêtes cross-origin (CORS)
    }),
    opacity:0.5,
    visible:false,
    title:"Biorégions géologie"
});

const brReliefWmsLayer0 = new TileLayer({
    source: new TileWMS({
        url: urlGeoserver+'ref_geo/wms', // URL du service WMS
        params: {
            'LAYERS': 'ref_geo:br_relief',
            'TILED': true
        },
        serverType: 'geoserver',// Type de serveur WMS (ex: geoserver)
        crossOrigin: 'anonymous'// Permet les requêtes cross-origin (CORS)
    }),
    opacity:0.5,
    visible:false,
    title:"Biorégions relief"
});

const brTempWmsLayer0 = new TileLayer({
    source: new TileWMS({
        url: urlGeoserver+'ref_geo/wms', // URL du service WMS
        params: {
            'LAYERS': 'ref_geo:br_t_moy_1950',
            'TILED': true
        },
        serverType: 'geoserver',// Type de serveur WMS (ex: geoserver)
        crossOrigin: 'anonymous'// Permet les requêtes cross-origin (CORS)
    }),
    opacity:0.5,
    visible:false,
    title:"Biorégions Températures"
});


export const brForetWmsLayer = brForetWmsLayer0;
export const brGeologieWmsLayer = brGeologieWmsLayer0;
export const brReliefWmsLayer = brReliefWmsLayer0;
export const brTempWmsLayer = brTempWmsLayer0;

export const bvWmsLayer = new ImageLayer({
    source: new ImageWMS({
        url: urlGeoserver+'ref_geo/wms', // URL du service WMS
        params: {
            'LAYERS': 'ref_geo:bassin_versant',
            'TILED': false,
            'STYLES' : 'br_bassin_versant'
        },
        serverType: 'geoserver',// Type de serveur WMS (ex: geoserver)
        crossOrigin: 'anonymous'// Permet les requêtes cross-origin (CORS)
    }),
    visible:false,
    title:"Bassins versants"
});

export const communesWmsLayer =  new ImageLayer({
    source: new ImageWMS({
        url: urlGeoserver+'ref_geo/wms', // URL du service WMS
        params: {
            'LAYERS': 'ref_geo:vm_commune',
            'TILED': true
        },
        serverType: 'geoserver',// Type de serveur WMS (ex: geoserver)
        crossOrigin: 'anonymous'// Permet les requêtes cross-origin (CORS)
    }),
    visible:false,
    title:"Villes et villages"
});